/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in FollowVisits [Visits control] page.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useVisitsControlTour = () => {
  const {
    visitsControlS1P1,
    visitsControlS1P2,
    visitsControlS2P1,
    visitsControlS2P2,
    visitsControlS2P3,
    visitsControlS3P1,
    visitsControlS3P2,
    visitsControlS3P3,
  } = useTranslationHook();

  return [
    {
      selector: ".start-visits-control-tour",
      content: (
        <Typography>
          <strong>{visitsControlS1P1}</strong> <br />
          {visitsControlS1P2}
        </Typography>
      ),
      stepInteraction: false,
    },
    {
        selector: ".visits-control-status-tour",
        content: (
          <Typography>
            {visitsControlS2P1} <strong>{visitsControlS2P2}</strong> {visitsControlS2P3}
          </Typography>
        ),
        stepInteraction: false,
    },
    {
        selector: ".visits-control-actions-tour",
        content: (
          <Typography>
            {visitsControlS3P1} <strong>{visitsControlS3P2}</strong> {visitsControlS3P3}
          </Typography>
        ),
        stepInteraction: false,
      },
  ];
};

export default useVisitsControlTour;
